// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _getV1UserActivity = async (url: string, request: Types.GetV1UserActivityRequest): Promise<Types.GetV1UserActivityResponses> => {
  const queryParameters: (keyof Types.GetV1UserActivityRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user-activity/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1UserActivity: Api['getV1UserActivity'] = async (request: Types.GetV1UserActivityRequest): Promise<Types.GetV1UserActivityResponses> => {
  return await _getV1UserActivity(baseUrl, request)
}
const _postV1UserActivity = async (url: string, request: Types.PostV1UserActivityRequest): Promise<Types.PostV1UserActivityResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/user-activity/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1UserActivity: Api['postV1UserActivity'] = async (request: Types.PostV1UserActivityRequest): Promise<Types.PostV1UserActivityResponses> => {
  return await _postV1UserActivity(baseUrl, request)
}
const _postV1FormBuilder = async (url: string, request: Types.PostV1FormBuilderRequest): Promise<Types.PostV1FormBuilderResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/form-builder/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FormBuilder: Api['postV1FormBuilder'] = async (request: Types.PostV1FormBuilderRequest): Promise<Types.PostV1FormBuilderResponses> => {
  return await _postV1FormBuilder(baseUrl, request)
}
const _getV1FormBuilder = async (url: string, request: Types.GetV1FormBuilderRequest): Promise<Types.GetV1FormBuilderResponses> => {
  const queryParameters: (keyof Types.GetV1FormBuilderRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/form-builder/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FormBuilder: Api['getV1FormBuilder'] = async (request: Types.GetV1FormBuilderRequest): Promise<Types.GetV1FormBuilderResponses> => {
  return await _getV1FormBuilder(baseUrl, request)
}
const _getV1FormBuilderId = async (url: string, request: Types.GetV1FormBuilderIdRequest): Promise<Types.GetV1FormBuilderIdResponses> => {
  const queryParameters: (keyof Types.GetV1FormBuilderIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/form-builder/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FormBuilderId: Api['getV1FormBuilderId'] = async (request: Types.GetV1FormBuilderIdRequest): Promise<Types.GetV1FormBuilderIdResponses> => {
  return await _getV1FormBuilderId(baseUrl, request)
}
const _patchV1FormBuilderId = async (url: string, request: Types.PatchV1FormBuilderIdRequest): Promise<Types.PatchV1FormBuilderIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/form-builder/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1FormBuilderId: Api['patchV1FormBuilderId'] = async (request: Types.PatchV1FormBuilderIdRequest): Promise<Types.PatchV1FormBuilderIdResponses> => {
  return await _patchV1FormBuilderId(baseUrl, request)
}
const _getV1FormBuilderFieldsId = async (url: string, request: Types.GetV1FormBuilderFieldsIdRequest): Promise<Types.GetV1FormBuilderFieldsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/form-builder/fields/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FormBuilderFieldsId: Api['getV1FormBuilderFieldsId'] = async (request: Types.GetV1FormBuilderFieldsIdRequest): Promise<Types.GetV1FormBuilderFieldsIdResponses> => {
  return await _getV1FormBuilderFieldsId(baseUrl, request)
}
const _getV1FormBuilderSchemaFieldsName = async (url: string, request: Types.GetV1FormBuilderSchemaFieldsNameRequest): Promise<Types.GetV1FormBuilderSchemaFieldsNameResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/form-builder/schema-fields/${request['name']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FormBuilderSchemaFieldsName: Api['getV1FormBuilderSchemaFieldsName'] = async (request: Types.GetV1FormBuilderSchemaFieldsNameRequest): Promise<Types.GetV1FormBuilderSchemaFieldsNameResponses> => {
  return await _getV1FormBuilderSchemaFieldsName(baseUrl, request)
}
const _getV1FormBuilderRelationalSchemaFieldsName = async (url: string, request: Types.GetV1FormBuilderRelationalSchemaFieldsNameRequest): Promise<Types.GetV1FormBuilderRelationalSchemaFieldsNameResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/form-builder/relational-schema-fields/${request['name']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FormBuilderRelationalSchemaFieldsName: Api['getV1FormBuilderRelationalSchemaFieldsName'] = async (request: Types.GetV1FormBuilderRelationalSchemaFieldsNameRequest): Promise<Types.GetV1FormBuilderRelationalSchemaFieldsNameResponses> => {
  return await _getV1FormBuilderRelationalSchemaFieldsName(baseUrl, request)
}
const _getV1FilterResource = async (url: string, request: Types.GetV1FilterResourceRequest): Promise<Types.GetV1FilterResourceResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/filter/${request['resource']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FilterResource: Api['getV1FilterResource'] = async (request: Types.GetV1FilterResourceRequest): Promise<Types.GetV1FilterResourceResponses> => {
  return await _getV1FilterResource(baseUrl, request)
}
const _getV1FilterFilterTable = async (url: string, request: Types.GetV1FilterFilterTableRequest): Promise<Types.GetV1FilterFilterTableResponses> => {
  const queryParameters: (keyof Types.GetV1FilterFilterTableRequest)[]  = ['offset', 'limit', 'search', 'table']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/filter/filter-table?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FilterFilterTable: Api['getV1FilterFilterTable'] = async (request: Types.GetV1FilterFilterTableRequest): Promise<Types.GetV1FilterFilterTableResponses> => {
  return await _getV1FilterFilterTable(baseUrl, request)
}
const _postV1Filter = async (url: string, request: Types.PostV1FilterRequest): Promise<Types.PostV1FilterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/filter/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Filter: Api['postV1Filter'] = async (request: Types.PostV1FilterRequest): Promise<Types.PostV1FilterResponses> => {
  return await _postV1Filter(baseUrl, request)
}
const _putV1FilterId = async (url: string, request: Types.PutV1FilterIdRequest): Promise<Types.PutV1FilterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/filter/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1FilterId: Api['putV1FilterId'] = async (request: Types.PutV1FilterIdRequest): Promise<Types.PutV1FilterIdResponses> => {
  return await _putV1FilterId(baseUrl, request)
}
const _deleteV1FilterId = async (url: string, request: Types.DeleteV1FilterIdRequest): Promise<Types.DeleteV1FilterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/filter/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1FilterId: Api['deleteV1FilterId'] = async (request: Types.DeleteV1FilterIdRequest): Promise<Types.DeleteV1FilterIdResponses> => {
  return await _deleteV1FilterId(baseUrl, request)
}
const _getV1Dashboard = async (url: string, request: Types.GetV1DashboardRequest): Promise<Types.GetV1DashboardResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Dashboard: Api['getV1Dashboard'] = async (request: Types.GetV1DashboardRequest): Promise<Types.GetV1DashboardResponses> => {
  return await _getV1Dashboard(baseUrl, request)
}
const _postV1Dashboard = async (url: string, request: Types.PostV1DashboardRequest): Promise<Types.PostV1DashboardResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Dashboard: Api['postV1Dashboard'] = async (request: Types.PostV1DashboardRequest): Promise<Types.PostV1DashboardResponses> => {
  return await _postV1Dashboard(baseUrl, request)
}
const _getV1DashboardId = async (url: string, request: Types.GetV1DashboardIdRequest): Promise<Types.GetV1DashboardIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardId: Api['getV1DashboardId'] = async (request: Types.GetV1DashboardIdRequest): Promise<Types.GetV1DashboardIdResponses> => {
  return await _getV1DashboardId(baseUrl, request)
}
const _putV1DashboardId = async (url: string, request: Types.PutV1DashboardIdRequest): Promise<Types.PutV1DashboardIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DashboardId: Api['putV1DashboardId'] = async (request: Types.PutV1DashboardIdRequest): Promise<Types.PutV1DashboardIdResponses> => {
  return await _putV1DashboardId(baseUrl, request)
}
const _deleteV1DashboardId = async (url: string, request: Types.DeleteV1DashboardIdRequest): Promise<Types.DeleteV1DashboardIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DashboardId: Api['deleteV1DashboardId'] = async (request: Types.DeleteV1DashboardIdRequest): Promise<Types.DeleteV1DashboardIdResponses> => {
  return await _deleteV1DashboardId(baseUrl, request)
}
const _getV1DashboardMetrics = async (url: string, request: Types.GetV1DashboardMetricsRequest): Promise<Types.GetV1DashboardMetricsResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/metrics`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardMetrics: Api['getV1DashboardMetrics'] = async (request: Types.GetV1DashboardMetricsRequest): Promise<Types.GetV1DashboardMetricsResponses> => {
  return await _getV1DashboardMetrics(baseUrl, request)
}
const _getV1DashboardRecent = async (url: string, request: Types.GetV1DashboardRecentRequest): Promise<Types.GetV1DashboardRecentResponses> => {
  const queryParameters: (keyof Types.GetV1DashboardRecentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/dashboard/recent?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DashboardRecent: Api['getV1DashboardRecent'] = async (request: Types.GetV1DashboardRecentRequest): Promise<Types.GetV1DashboardRecentResponses> => {
  return await _getV1DashboardRecent(baseUrl, request)
}
const _getV1PagesResource = async (url: string, request: Types.GetV1PagesResourceRequest): Promise<Types.GetV1PagesResourceResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/pages/${request['resource']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PagesResource: Api['getV1PagesResource'] = async (request: Types.GetV1PagesResourceRequest): Promise<Types.GetV1PagesResourceResponses> => {
  return await _getV1PagesResource(baseUrl, request)
}
const _patchV1PagesPageId = async (url: string, request: Types.PatchV1PagesPageIdRequest): Promise<Types.PatchV1PagesPageIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/pages/${request['page_id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1PagesPageId: Api['patchV1PagesPageId'] = async (request: Types.PatchV1PagesPageIdRequest): Promise<Types.PatchV1PagesPageIdResponses> => {
  return await _patchV1PagesPageId(baseUrl, request)
}
const _postV1PagesShare = async (url: string, request: Types.PostV1PagesShareRequest): Promise<Types.PostV1PagesShareResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/pages/share`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PagesShare: Api['postV1PagesShare'] = async (request: Types.PostV1PagesShareRequest): Promise<Types.PostV1PagesShareResponses> => {
  return await _postV1PagesShare(baseUrl, request)
}
const _getV1PagesUserList = async (url: string, request: Types.GetV1PagesUserListRequest): Promise<Types.GetV1PagesUserListResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/pages/user-list`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PagesUserList: Api['getV1PagesUserList'] = async (request: Types.GetV1PagesUserListRequest): Promise<Types.GetV1PagesUserListResponses> => {
  return await _getV1PagesUserList(baseUrl, request)
}
const _postV1WorkflowAutomation = async (url: string, request: Types.PostV1WorkflowAutomationRequest): Promise<Types.PostV1WorkflowAutomationResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-automation/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkflowAutomation: Api['postV1WorkflowAutomation'] = async (request: Types.PostV1WorkflowAutomationRequest): Promise<Types.PostV1WorkflowAutomationResponses> => {
  return await _postV1WorkflowAutomation(baseUrl, request)
}
const _getV1WorkflowAutomation = async (url: string, request: Types.GetV1WorkflowAutomationRequest): Promise<Types.GetV1WorkflowAutomationResponses> => {
  const queryParameters: (keyof Types.GetV1WorkflowAutomationRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-automation/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowAutomation: Api['getV1WorkflowAutomation'] = async (request: Types.GetV1WorkflowAutomationRequest): Promise<Types.GetV1WorkflowAutomationResponses> => {
  return await _getV1WorkflowAutomation(baseUrl, request)
}
const _getV1WorkflowAutomationId = async (url: string, request: Types.GetV1WorkflowAutomationIdRequest): Promise<Types.GetV1WorkflowAutomationIdResponses> => {
  const queryParameters: (keyof Types.GetV1WorkflowAutomationIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-automation/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowAutomationId: Api['getV1WorkflowAutomationId'] = async (request: Types.GetV1WorkflowAutomationIdRequest): Promise<Types.GetV1WorkflowAutomationIdResponses> => {
  return await _getV1WorkflowAutomationId(baseUrl, request)
}
const _putV1WorkflowAutomationId = async (url: string, request: Types.PutV1WorkflowAutomationIdRequest): Promise<Types.PutV1WorkflowAutomationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-automation/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1WorkflowAutomationId: Api['putV1WorkflowAutomationId'] = async (request: Types.PutV1WorkflowAutomationIdRequest): Promise<Types.PutV1WorkflowAutomationIdResponses> => {
  return await _putV1WorkflowAutomationId(baseUrl, request)
}
const _deleteV1WorkflowAutomationId = async (url: string, request: Types.DeleteV1WorkflowAutomationIdRequest): Promise<Types.DeleteV1WorkflowAutomationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-automation/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1WorkflowAutomationId: Api['deleteV1WorkflowAutomationId'] = async (request: Types.DeleteV1WorkflowAutomationIdRequest): Promise<Types.DeleteV1WorkflowAutomationIdResponses> => {
  return await _deleteV1WorkflowAutomationId(baseUrl, request)
}
const _getV1WorkflowAutomationTemplates = async (url: string, request: Types.GetV1WorkflowAutomationTemplatesRequest): Promise<Types.GetV1WorkflowAutomationTemplatesResponses> => {
  const queryParameters: (keyof Types.GetV1WorkflowAutomationTemplatesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-automation/templates?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1WorkflowAutomationTemplates: Api['getV1WorkflowAutomationTemplates'] = async (request: Types.GetV1WorkflowAutomationTemplatesRequest): Promise<Types.GetV1WorkflowAutomationTemplatesResponses> => {
  return await _getV1WorkflowAutomationTemplates(baseUrl, request)
}
const _patchV1WorkflowAutomationStatusId = async (url: string, request: Types.PatchV1WorkflowAutomationStatusIdRequest): Promise<Types.PatchV1WorkflowAutomationStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-automation/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1WorkflowAutomationStatusId: Api['patchV1WorkflowAutomationStatusId'] = async (request: Types.PatchV1WorkflowAutomationStatusIdRequest): Promise<Types.PatchV1WorkflowAutomationStatusIdResponses> => {
  return await _patchV1WorkflowAutomationStatusId(baseUrl, request)
}
const _postV1WorkflowAutomationPlayId = async (url: string, request: Types.PostV1WorkflowAutomationPlayIdRequest): Promise<Types.PostV1WorkflowAutomationPlayIdResponses> => {
  const queryParameters: (keyof Types.PostV1WorkflowAutomationPlayIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/workflow-automation/play/${request['id']}?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1WorkflowAutomationPlayId: Api['postV1WorkflowAutomationPlayId'] = async (request: Types.PostV1WorkflowAutomationPlayIdRequest): Promise<Types.PostV1WorkflowAutomationPlayIdResponses> => {
  return await _postV1WorkflowAutomationPlayId(baseUrl, request)
}
const _getV1Languages = async (url: string, request: Types.GetV1LanguagesRequest): Promise<Types.GetV1LanguagesResponses> => {
  const queryParameters: (keyof Types.GetV1LanguagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Languages: Api['getV1Languages'] = async (request: Types.GetV1LanguagesRequest): Promise<Types.GetV1LanguagesResponses> => {
  return await _getV1Languages(baseUrl, request)
}
const _postV1Languages = async (url: string, request: Types.PostV1LanguagesRequest): Promise<Types.PostV1LanguagesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Languages: Api['postV1Languages'] = async (request: Types.PostV1LanguagesRequest): Promise<Types.PostV1LanguagesResponses> => {
  return await _postV1Languages(baseUrl, request)
}
const _getV1LanguagesId = async (url: string, request: Types.GetV1LanguagesIdRequest): Promise<Types.GetV1LanguagesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LanguagesId: Api['getV1LanguagesId'] = async (request: Types.GetV1LanguagesIdRequest): Promise<Types.GetV1LanguagesIdResponses> => {
  return await _getV1LanguagesId(baseUrl, request)
}
const _putV1LanguagesId = async (url: string, request: Types.PutV1LanguagesIdRequest): Promise<Types.PutV1LanguagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LanguagesId: Api['putV1LanguagesId'] = async (request: Types.PutV1LanguagesIdRequest): Promise<Types.PutV1LanguagesIdResponses> => {
  return await _putV1LanguagesId(baseUrl, request)
}
const _deleteV1LanguagesId = async (url: string, request: Types.DeleteV1LanguagesIdRequest): Promise<Types.DeleteV1LanguagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LanguagesId: Api['deleteV1LanguagesId'] = async (request: Types.DeleteV1LanguagesIdRequest): Promise<Types.DeleteV1LanguagesIdResponses> => {
  return await _deleteV1LanguagesId(baseUrl, request)
}
const _getV1LanguagesTranslationsGenerateExcel = async (url: string, request: Types.GetV1LanguagesTranslationsGenerateExcelRequest): Promise<Types.GetV1LanguagesTranslationsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1LanguagesTranslationsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/languages/translations/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LanguagesTranslationsGenerateExcel: Api['getV1LanguagesTranslationsGenerateExcel'] = async (request: Types.GetV1LanguagesTranslationsGenerateExcelRequest): Promise<Types.GetV1LanguagesTranslationsGenerateExcelResponses> => {
  return await _getV1LanguagesTranslationsGenerateExcel(baseUrl, request)
}
const _postV1LanguagesLangIdModuleTranslationsImport = async (url: string, request: Types.PostV1LanguagesLangIdModuleTranslationsImportRequest): Promise<Types.PostV1LanguagesLangIdModuleTranslationsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/${request['langId']}/${request['module']}/translations/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LanguagesLangIdModuleTranslationsImport: Api['postV1LanguagesLangIdModuleTranslationsImport'] = async (request: Types.PostV1LanguagesLangIdModuleTranslationsImportRequest): Promise<Types.PostV1LanguagesLangIdModuleTranslationsImportResponses> => {
  return await _postV1LanguagesLangIdModuleTranslationsImport(baseUrl, request)
}
const _getV1LanguagesTranslations = async (url: string, request: Types.GetV1LanguagesTranslationsRequest): Promise<Types.GetV1LanguagesTranslationsResponses> => {
  const queryParameters: (keyof Types.GetV1LanguagesTranslationsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/translations?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LanguagesTranslations: Api['getV1LanguagesTranslations'] = async (request: Types.GetV1LanguagesTranslationsRequest): Promise<Types.GetV1LanguagesTranslationsResponses> => {
  return await _getV1LanguagesTranslations(baseUrl, request)
}
const _postV1LanguagesTranslations = async (url: string, request: Types.PostV1LanguagesTranslationsRequest): Promise<Types.PostV1LanguagesTranslationsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/translations`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LanguagesTranslations: Api['postV1LanguagesTranslations'] = async (request: Types.PostV1LanguagesTranslationsRequest): Promise<Types.PostV1LanguagesTranslationsResponses> => {
  return await _postV1LanguagesTranslations(baseUrl, request)
}
const _getV1LanguagesModules = async (url: string, request: Types.GetV1LanguagesModulesRequest): Promise<Types.GetV1LanguagesModulesResponses> => {
  const queryParameters: (keyof Types.GetV1LanguagesModulesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/languages/modules?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LanguagesModules: Api['getV1LanguagesModules'] = async (request: Types.GetV1LanguagesModulesRequest): Promise<Types.GetV1LanguagesModulesResponses> => {
  return await _getV1LanguagesModules(baseUrl, request)
}
const _getV1Templates = async (url: string, request: Types.GetV1TemplatesRequest): Promise<Types.GetV1TemplatesResponses> => {
  const queryParameters: (keyof Types.GetV1TemplatesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'subject', 'resource', 'module', 'company_id']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/templates/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Templates: Api['getV1Templates'] = async (request: Types.GetV1TemplatesRequest): Promise<Types.GetV1TemplatesResponses> => {
  return await _getV1Templates(baseUrl, request)
}
const _postV1Templates = async (url: string, request: Types.PostV1TemplatesRequest): Promise<Types.PostV1TemplatesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/templates/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Templates: Api['postV1Templates'] = async (request: Types.PostV1TemplatesRequest): Promise<Types.PostV1TemplatesResponses> => {
  return await _postV1Templates(baseUrl, request)
}
const _patchV1TemplatesId = async (url: string, request: Types.PatchV1TemplatesIdRequest): Promise<Types.PatchV1TemplatesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/templates/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TemplatesId: Api['patchV1TemplatesId'] = async (request: Types.PatchV1TemplatesIdRequest): Promise<Types.PatchV1TemplatesIdResponses> => {
  return await _patchV1TemplatesId(baseUrl, request)
}
const _deleteV1TemplatesId = async (url: string, request: Types.DeleteV1TemplatesIdRequest): Promise<Types.DeleteV1TemplatesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/templates/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1TemplatesId: Api['deleteV1TemplatesId'] = async (request: Types.DeleteV1TemplatesIdRequest): Promise<Types.DeleteV1TemplatesIdResponses> => {
  return await _deleteV1TemplatesId(baseUrl, request)
}
const _getV1TemplatesId = async (url: string, request: Types.GetV1TemplatesIdRequest): Promise<Types.GetV1TemplatesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/templates/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TemplatesId: Api['getV1TemplatesId'] = async (request: Types.GetV1TemplatesIdRequest): Promise<Types.GetV1TemplatesIdResponses> => {
  return await _getV1TemplatesId(baseUrl, request)
}
const _patchV1TemplatesIdSetDefault = async (url: string, request: Types.PatchV1TemplatesIdSetDefaultRequest): Promise<Types.PatchV1TemplatesIdSetDefaultResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/templates/${request['id']}/set-default`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TemplatesIdSetDefault: Api['patchV1TemplatesIdSetDefault'] = async (request: Types.PatchV1TemplatesIdSetDefaultRequest): Promise<Types.PatchV1TemplatesIdSetDefaultResponses> => {
  return await _patchV1TemplatesIdSetDefault(baseUrl, request)
}
const _getV1Subjects = async (url: string, request: Types.GetV1SubjectsRequest): Promise<Types.GetV1SubjectsResponses> => {
  const queryParameters: (keyof Types.GetV1SubjectsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/subjects/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Subjects: Api['getV1Subjects'] = async (request: Types.GetV1SubjectsRequest): Promise<Types.GetV1SubjectsResponses> => {
  return await _getV1Subjects(baseUrl, request)
}
const _postV1Subjects = async (url: string, request: Types.PostV1SubjectsRequest): Promise<Types.PostV1SubjectsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/subjects/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Subjects: Api['postV1Subjects'] = async (request: Types.PostV1SubjectsRequest): Promise<Types.PostV1SubjectsResponses> => {
  return await _postV1Subjects(baseUrl, request)
}
const _patchV1SubjectsId = async (url: string, request: Types.PatchV1SubjectsIdRequest): Promise<Types.PatchV1SubjectsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/subjects/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1SubjectsId: Api['patchV1SubjectsId'] = async (request: Types.PatchV1SubjectsIdRequest): Promise<Types.PatchV1SubjectsIdResponses> => {
  return await _patchV1SubjectsId(baseUrl, request)
}
const _getV1SubjectsId = async (url: string, request: Types.GetV1SubjectsIdRequest): Promise<Types.GetV1SubjectsIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/subjects/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SubjectsId: Api['getV1SubjectsId'] = async (request: Types.GetV1SubjectsIdRequest): Promise<Types.GetV1SubjectsIdResponses> => {
  return await _getV1SubjectsId(baseUrl, request)
}
const _getV1TemplateHeaderFooter = async (url: string, request: Types.GetV1TemplateHeaderFooterRequest): Promise<Types.GetV1TemplateHeaderFooterResponses> => {
  const queryParameters: (keyof Types.GetV1TemplateHeaderFooterRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select', 'company_id']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/template-header-footer/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TemplateHeaderFooter: Api['getV1TemplateHeaderFooter'] = async (request: Types.GetV1TemplateHeaderFooterRequest): Promise<Types.GetV1TemplateHeaderFooterResponses> => {
  return await _getV1TemplateHeaderFooter(baseUrl, request)
}
const _postV1TemplateHeaderFooter = async (url: string, request: Types.PostV1TemplateHeaderFooterRequest): Promise<Types.PostV1TemplateHeaderFooterResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/template-header-footer/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1TemplateHeaderFooter: Api['postV1TemplateHeaderFooter'] = async (request: Types.PostV1TemplateHeaderFooterRequest): Promise<Types.PostV1TemplateHeaderFooterResponses> => {
  return await _postV1TemplateHeaderFooter(baseUrl, request)
}
const _patchV1TemplateHeaderFooterId = async (url: string, request: Types.PatchV1TemplateHeaderFooterIdRequest): Promise<Types.PatchV1TemplateHeaderFooterIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/template-header-footer/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1TemplateHeaderFooterId: Api['patchV1TemplateHeaderFooterId'] = async (request: Types.PatchV1TemplateHeaderFooterIdRequest): Promise<Types.PatchV1TemplateHeaderFooterIdResponses> => {
  return await _patchV1TemplateHeaderFooterId(baseUrl, request)
}
const _getV1TemplateHeaderFooterId = async (url: string, request: Types.GetV1TemplateHeaderFooterIdRequest): Promise<Types.GetV1TemplateHeaderFooterIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/template-header-footer/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TemplateHeaderFooterId: Api['getV1TemplateHeaderFooterId'] = async (request: Types.GetV1TemplateHeaderFooterIdRequest): Promise<Types.GetV1TemplateHeaderFooterIdResponses> => {
  return await _getV1TemplateHeaderFooterId(baseUrl, request)
}
const _getV1TemplateHeaderFooterCompanyIdHeaderFooter = async (url: string, request: Types.GetV1TemplateHeaderFooterCompanyIdHeaderFooterRequest): Promise<Types.GetV1TemplateHeaderFooterCompanyIdHeaderFooterResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/template-header-footer/${request['company_id']}/header-footer`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1TemplateHeaderFooterCompanyIdHeaderFooter: Api['getV1TemplateHeaderFooterCompanyIdHeaderFooter'] = async (request: Types.GetV1TemplateHeaderFooterCompanyIdHeaderFooterRequest): Promise<Types.GetV1TemplateHeaderFooterCompanyIdHeaderFooterResponses> => {
  return await _getV1TemplateHeaderFooterCompanyIdHeaderFooter(baseUrl, request)
}
const _getV1Notification = async (url: string, request: Types.GetV1NotificationRequest): Promise<Types.GetV1NotificationResponses> => {
  const queryParameters: (keyof Types.GetV1NotificationRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/notification/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Notification: Api['getV1Notification'] = async (request: Types.GetV1NotificationRequest): Promise<Types.GetV1NotificationResponses> => {
  return await _getV1Notification(baseUrl, request)
}
const _patchV1NotificationMarkAsReadId = async (url: string, request: Types.PatchV1NotificationMarkAsReadIdRequest): Promise<Types.PatchV1NotificationMarkAsReadIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/notification/mark-as-read/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1NotificationMarkAsReadId: Api['patchV1NotificationMarkAsReadId'] = async (request: Types.PatchV1NotificationMarkAsReadIdRequest): Promise<Types.PatchV1NotificationMarkAsReadIdResponses> => {
  return await _patchV1NotificationMarkAsReadId(baseUrl, request)
}
const _getV1NotificationMarkAllAsRead = async (url: string, request: Types.GetV1NotificationMarkAllAsReadRequest): Promise<Types.GetV1NotificationMarkAllAsReadResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/notification/mark-all-as-read`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1NotificationMarkAllAsRead: Api['getV1NotificationMarkAllAsRead'] = async (request: Types.GetV1NotificationMarkAllAsReadRequest): Promise<Types.GetV1NotificationMarkAllAsReadResponses> => {
  return await _getV1NotificationMarkAllAsRead(baseUrl, request)
}
const _postV1ReportsScheduleReport = async (url: string, request: Types.PostV1ReportsScheduleReportRequest): Promise<Types.PostV1ReportsScheduleReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/schedule-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsScheduleReport: Api['postV1ReportsScheduleReport'] = async (request: Types.PostV1ReportsScheduleReportRequest): Promise<Types.PostV1ReportsScheduleReportResponses> => {
  return await _postV1ReportsScheduleReport(baseUrl, request)
}
const _getV1ReportsScheduleReport = async (url: string, request: Types.GetV1ReportsScheduleReportRequest): Promise<Types.GetV1ReportsScheduleReportResponses> => {
  const queryParameters: (keyof Types.GetV1ReportsScheduleReportRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/schedule-report?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReportsScheduleReport: Api['getV1ReportsScheduleReport'] = async (request: Types.GetV1ReportsScheduleReportRequest): Promise<Types.GetV1ReportsScheduleReportResponses> => {
  return await _getV1ReportsScheduleReport(baseUrl, request)
}
const _putV1ReportsUpdateScheduleReportId = async (url: string, request: Types.PutV1ReportsUpdateScheduleReportIdRequest): Promise<Types.PutV1ReportsUpdateScheduleReportIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/update-schedule-report/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ReportsUpdateScheduleReportId: Api['putV1ReportsUpdateScheduleReportId'] = async (request: Types.PutV1ReportsUpdateScheduleReportIdRequest): Promise<Types.PutV1ReportsUpdateScheduleReportIdResponses> => {
  return await _putV1ReportsUpdateScheduleReportId(baseUrl, request)
}
const _deleteV1ReportsScheduleReportId = async (url: string, request: Types.DeleteV1ReportsScheduleReportIdRequest): Promise<Types.DeleteV1ReportsScheduleReportIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/schedule-report/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ReportsScheduleReportId: Api['deleteV1ReportsScheduleReportId'] = async (request: Types.DeleteV1ReportsScheduleReportIdRequest): Promise<Types.DeleteV1ReportsScheduleReportIdResponses> => {
  return await _deleteV1ReportsScheduleReportId(baseUrl, request)
}
const _getV1ReportsReportIdScheduleReport = async (url: string, request: Types.GetV1ReportsReportIdScheduleReportRequest): Promise<Types.GetV1ReportsReportIdScheduleReportResponses> => {
  const queryParameters: (keyof Types.GetV1ReportsReportIdScheduleReportRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/${request['report_id']}/schedule-report?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReportsReportIdScheduleReport: Api['getV1ReportsReportIdScheduleReport'] = async (request: Types.GetV1ReportsReportIdScheduleReportRequest): Promise<Types.GetV1ReportsReportIdScheduleReportResponses> => {
  return await _getV1ReportsReportIdScheduleReport(baseUrl, request)
}
const _getV1ReportsReportList = async (url: string, request: Types.GetV1ReportsReportListRequest): Promise<Types.GetV1ReportsReportListResponses> => {
  const queryParameters: (keyof Types.GetV1ReportsReportListRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/report-list?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ReportsReportList: Api['getV1ReportsReportList'] = async (request: Types.GetV1ReportsReportListRequest): Promise<Types.GetV1ReportsReportListResponses> => {
  return await _getV1ReportsReportList(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    getV1UserActivity: _getV1UserActivity.bind(url, ...arguments),
    postV1UserActivity: _postV1UserActivity.bind(url, ...arguments),
    postV1FormBuilder: _postV1FormBuilder.bind(url, ...arguments),
    getV1FormBuilder: _getV1FormBuilder.bind(url, ...arguments),
    getV1FormBuilderId: _getV1FormBuilderId.bind(url, ...arguments),
    patchV1FormBuilderId: _patchV1FormBuilderId.bind(url, ...arguments),
    getV1FormBuilderFieldsId: _getV1FormBuilderFieldsId.bind(url, ...arguments),
    getV1FormBuilderSchemaFieldsName: _getV1FormBuilderSchemaFieldsName.bind(url, ...arguments),
    getV1FormBuilderRelationalSchemaFieldsName: _getV1FormBuilderRelationalSchemaFieldsName.bind(url, ...arguments),
    getV1FilterResource: _getV1FilterResource.bind(url, ...arguments),
    getV1FilterFilterTable: _getV1FilterFilterTable.bind(url, ...arguments),
    postV1Filter: _postV1Filter.bind(url, ...arguments),
    putV1FilterId: _putV1FilterId.bind(url, ...arguments),
    deleteV1FilterId: _deleteV1FilterId.bind(url, ...arguments),
    getV1Dashboard: _getV1Dashboard.bind(url, ...arguments),
    postV1Dashboard: _postV1Dashboard.bind(url, ...arguments),
    getV1DashboardId: _getV1DashboardId.bind(url, ...arguments),
    putV1DashboardId: _putV1DashboardId.bind(url, ...arguments),
    deleteV1DashboardId: _deleteV1DashboardId.bind(url, ...arguments),
    getV1DashboardMetrics: _getV1DashboardMetrics.bind(url, ...arguments),
    getV1DashboardRecent: _getV1DashboardRecent.bind(url, ...arguments),
    getV1PagesResource: _getV1PagesResource.bind(url, ...arguments),
    patchV1PagesPageId: _patchV1PagesPageId.bind(url, ...arguments),
    postV1PagesShare: _postV1PagesShare.bind(url, ...arguments),
    getV1PagesUserList: _getV1PagesUserList.bind(url, ...arguments),
    postV1WorkflowAutomation: _postV1WorkflowAutomation.bind(url, ...arguments),
    getV1WorkflowAutomation: _getV1WorkflowAutomation.bind(url, ...arguments),
    getV1WorkflowAutomationId: _getV1WorkflowAutomationId.bind(url, ...arguments),
    putV1WorkflowAutomationId: _putV1WorkflowAutomationId.bind(url, ...arguments),
    deleteV1WorkflowAutomationId: _deleteV1WorkflowAutomationId.bind(url, ...arguments),
    getV1WorkflowAutomationTemplates: _getV1WorkflowAutomationTemplates.bind(url, ...arguments),
    patchV1WorkflowAutomationStatusId: _patchV1WorkflowAutomationStatusId.bind(url, ...arguments),
    postV1WorkflowAutomationPlayId: _postV1WorkflowAutomationPlayId.bind(url, ...arguments),
    getV1Languages: _getV1Languages.bind(url, ...arguments),
    postV1Languages: _postV1Languages.bind(url, ...arguments),
    getV1LanguagesId: _getV1LanguagesId.bind(url, ...arguments),
    putV1LanguagesId: _putV1LanguagesId.bind(url, ...arguments),
    deleteV1LanguagesId: _deleteV1LanguagesId.bind(url, ...arguments),
    getV1LanguagesTranslationsGenerateExcel: _getV1LanguagesTranslationsGenerateExcel.bind(url, ...arguments),
    postV1LanguagesLangIdModuleTranslationsImport: _postV1LanguagesLangIdModuleTranslationsImport.bind(url, ...arguments),
    getV1LanguagesTranslations: _getV1LanguagesTranslations.bind(url, ...arguments),
    postV1LanguagesTranslations: _postV1LanguagesTranslations.bind(url, ...arguments),
    getV1LanguagesModules: _getV1LanguagesModules.bind(url, ...arguments),
    getV1Templates: _getV1Templates.bind(url, ...arguments),
    postV1Templates: _postV1Templates.bind(url, ...arguments),
    patchV1TemplatesId: _patchV1TemplatesId.bind(url, ...arguments),
    deleteV1TemplatesId: _deleteV1TemplatesId.bind(url, ...arguments),
    getV1TemplatesId: _getV1TemplatesId.bind(url, ...arguments),
    patchV1TemplatesIdSetDefault: _patchV1TemplatesIdSetDefault.bind(url, ...arguments),
    getV1Subjects: _getV1Subjects.bind(url, ...arguments),
    postV1Subjects: _postV1Subjects.bind(url, ...arguments),
    patchV1SubjectsId: _patchV1SubjectsId.bind(url, ...arguments),
    getV1SubjectsId: _getV1SubjectsId.bind(url, ...arguments),
    getV1TemplateHeaderFooter: _getV1TemplateHeaderFooter.bind(url, ...arguments),
    postV1TemplateHeaderFooter: _postV1TemplateHeaderFooter.bind(url, ...arguments),
    patchV1TemplateHeaderFooterId: _patchV1TemplateHeaderFooterId.bind(url, ...arguments),
    getV1TemplateHeaderFooterId: _getV1TemplateHeaderFooterId.bind(url, ...arguments),
    getV1TemplateHeaderFooterCompanyIdHeaderFooter: _getV1TemplateHeaderFooterCompanyIdHeaderFooter.bind(url, ...arguments),
    getV1Notification: _getV1Notification.bind(url, ...arguments),
    patchV1NotificationMarkAsReadId: _patchV1NotificationMarkAsReadId.bind(url, ...arguments),
    getV1NotificationMarkAllAsRead: _getV1NotificationMarkAllAsRead.bind(url, ...arguments),
    postV1ReportsScheduleReport: _postV1ReportsScheduleReport.bind(url, ...arguments),
    getV1ReportsScheduleReport: _getV1ReportsScheduleReport.bind(url, ...arguments),
    putV1ReportsUpdateScheduleReportId: _putV1ReportsUpdateScheduleReportId.bind(url, ...arguments),
    deleteV1ReportsScheduleReportId: _deleteV1ReportsScheduleReportId.bind(url, ...arguments),
    getV1ReportsReportIdScheduleReport: _getV1ReportsReportIdScheduleReport.bind(url, ...arguments),
    getV1ReportsReportList: _getV1ReportsReportList.bind(url, ...arguments)
  }
}